module.exports = __webpack_public_path__ + "static/img/yangshen-4.ac95643.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/yangshen-4.png
// module id = bKHU
// module chunks = 0